import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import UIManager from "../../core/components/ui/UiBuilder";
import { alllanguage } from "../../data/lang/index";
import { Ilanguage } from "../../core/interface/Icommon";
import withWinShowerConfiguration from "./configuration/withWinShowerConfiguration";
import { isMobile } from "react-device-detect";
import { configGame, constant } from "../../data/config";
import { CURRENCY } from "../../core/utills";
import { actions as winShowerActions } from "../../gamereducer/winShowerReducer";
import { BaseAnimatedparticle } from "../../core/components/effect/baseanimatedparticle";
import { TIMER } from "../../core/utills";
import { actions as layoutssActions } from "../../core/reducers/layoutsStateReducer";
import { actions as buttonActions } from "../../core/reducers/buttonPanelReducer";
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { Tween } from "../../core/components/effect/tween";
import { actions as basegameAction } from "../../core/reducers/baseGameReducer";
import { actions as freegameAction } from "../../core/reducers/freeGameReducer";
import { actions as horizontalSymbolActions } from "../../gamereducer/horizontalSymbolReducer";
import { actions as retriggerActions } from "../../gamereducer/retriggerReducer";
import { actions as reelgridAction } from '../../core/reducers/reelgridStateReducer';
import { actions as flowManagerAction } from "../../core/reducers/flowManagerReducer";
import { actions as gameRandomWildActions } from '../../gamereducer/gameRandomWildReducer';
interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;
}

interface IStateToProps {
    [x: string]: any;
}

interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class WinShower extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected winShowerContainer: _ReactPixi.IContainer | Ref<any>;
    private alllanguage: Ilanguage;
    private tickupRequest: any;
    protected tweening: any;
    protected ui_mode: string;
    protected displayUI: any;
    protected thresholdSuperWin: any
    protected thresholdMegaWin: any
    protected thresholdLegendaryWin: any
    protected Baseparticle: any
    protected wincelebrationText: any
    protected wincelebrationTextPortrait: any
    protected currentCelebrationState: any
    private tweenTimer: number = 0.001;
    private level_1: number = 2000;
    private level_2: number = 3000;
    private level_3: number = 4000;
    private level_4: number = 5000;
    private threshold_level_1 = 5;
    private threshold_level_2 = 10;
    private threshold_level_3 = 15;
    private threshold_level_4 = 20;
    private constantValue: number = 100;
    private storeBetValue: number = 0;
    private frequency_1: number = 0.2;
    private frequency_2: number = 0.15;
    private frequency_3: number = 0.1;
    private frequency_4: number = 0.08;
    private maxParticle_1: number = 20;
    private maxParticle_2: number = 60;
    private maxParticle_3: number = 100;
    private maxParticle_4: number = 140;
    private isClicked: boolean = false;
    protected constantT1: number = 100;

    constructor(props: IProps) {
        super(props);
        this.app = props.app;

        this.alllanguage = alllanguage;
        this.state = {
            uiElements: [],
            lang: "en",
            width: this.props.width,
            height: this.props.height,
            pixelRatio: window.devicePixelRatio,
            resizing: false,
        }
        this.winShowerContainer = React.createRef();
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";

        }
        this.tweening = [];

        this.thresholdSuperWin = 100;
        this.thresholdMegaWin = 200;
        this.thresholdLegendaryWin = 500;
        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));
        //this.displayUI = this.props.child.filter(this.checkUiMode.bind(this));

    }

    checkUiMode(uimodeobj: any) {

        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both"
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    layoutChange(currentLayout: string) {
        this.displayUI.map((data: any, j: number) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )
    }


    componentDidMount() {
        if (this.props.showWinShower) {
            this.layoutChange(this.props.layoutMode);

        }

    }



    coinShower() {
        let coinConfig = {

            "alpha": {
                "start": 1,
                "end": 1
            },
            "scale": {
                "start": 0.3,
                "end": 0.6
            },
            "speed": {
                "start": 2000,
                "end": 2000
            },
            "acceleration": {
                "x": 10,
                "y": 1830
            },
            "startRotation": {
                "min": 250,
                "max": 290
            },
            "rotationSpeed": {
                "min": 100,
                "max": 150
            },
            "lifetime": {
                "min": 2,
                "max": 4
            },
            "frequency": 0.01,
            "emitterLifetime": -1,

            "maxParticles": 20,
            "pos": {
                "x": 900,
                "y": 1200
            },
            "addAtBack": false,
            "spawnType": "circle",
            "spawnCircle": {
                "x": 0,
                "y": 0,
                "r": 100
            }
        }

        let animmationconfig = {
            framerate: 30,
            loop: true,
            textures: UIManager.getRef("coins_Anim").textures
        }
        this.Baseparticle = new BaseAnimatedparticle(UIManager.getRef("winShower_Container_" + this.ui_mode), animmationconfig, coinConfig)
    }



    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        if (nextProps.soundIsPlaying !== this.props.soundIsPlaying
            || nextProps.allSoundSFXStop !== this.props.allSoundSFXStop
            || nextProps.showWinShower !== this.props.showWinShower
            || nextProps.startWinShower !== this.props.startWinShower
            || nextProps.layoutMode !== this.props.layoutMode) {
            if (nextProps.soundIsPlaying !== this.props.soundIsPlaying) {
                return false;
            }
            if (nextProps.layoutMode !== this.props.layoutMode && this.props.showWinShower) {
                this.layoutChange(nextProps.layoutMode);

            }
            if (nextProps.showWinShower && nextProps.showWinShower !== this.props.showWinShower) {
                return true;
            }
            if (nextProps.startWinShower && nextProps.startWinShower !== this.props.startWinShower) {
                this.storeBetValue = this.props.betList[this.props.currentBetIndex];
                this.coinShower();

                UIManager.getRef("amount_tickup_" + this.ui_mode).visible = false;
                this.interactivityTrue(true);
                let timer = TIMER.TimerManager.createTimer(100);
                timer.on('end', (e: any) => {
                    UIManager.getRef("amount_tickup_" + this.ui_mode).visible = true;
                    UIManager.getRef("winShower_Container_" + this.ui_mode).visible = true;
                    if (nextProps.soundIsPlaying && !nextProps.allSoundSFXStop) {
                        this.props.playSound([{ name: "tickupSound", loop: true }, { name: "coinShowerSound", loop: true }]);
                    }

                    this.setTimeOfWin();

                    let tickupAmount = 0;
                    if (nextProps.displayInCoins == false) {
                        tickupAmount = nextProps.winShowerAmount;
                    } else {
                        tickupAmount = nextProps.winShowerAmount * 10 / nextProps.betList[nextProps.currentBetIndex];

                    }

                    UIManager.getRef("amount_tickup_" + this.ui_mode).objectInstance.startTickup(tickupAmount);
                });
                timer.start();
            }
            return false;
        }
        return true;
    }

    interactivityTrue(value: boolean) {
        UIManager.getRef("winShowerContainer").buttonMode = true;
        UIManager.getRef("winShowerContainer").interactive = true;

        if (isMobile) {
            UIManager.getRef("winShowerContainer").addListener('touchend', (evt: MouseEvent): void => {
                this.handleEvents();
            })
        } else {
            UIManager.getRef("winShowerContainer").click = (event: any) => {
                this.handleEvents();
            }



        }
    }
    handleEventMouseOver() { }
    handleEventMouseOut() { }
    handleEvents() {
        this.isClicked = true;
        //this.isClicked = true;
        //this.props.stopSound([{ name: this.previousSound }]);
        //UIManager.getRef("Text_amount_tickup_" + this.ui_mode).objectInstance.stopTickup();
        //this.tickUpValue = this.props.totalCreditWinAmount / 100;
        //let timer = TIMER.TimerManager.createTimer(this.handleEventTimer);
        //timer.on('end', () => {
        //    this.isClicked = false;
        //    this.CloseScreen();


        //});
        //timer.start(false, this.handleEventTimer);

    }
    setTimeOfWin() {
        if (this.props.totalCreditWinAmount < this.threshold_level_1 * this.storeBetValue) {
            this.Baseparticle.maxParticles = this.maxParticle_1;
            this.Baseparticle.frequency = this.frequency_1;
            UIManager.getRef("amount_tickup_" + this.ui_mode).tickuptime = this.level_1;
            this.playWinLevelSound("winLevel_1")

        }
        else if (this.props.totalCreditWinAmount >= this.threshold_level_1 * this.storeBetValue && this.props.totalCreditWinAmount < this.threshold_level_2 * this.storeBetValue) {
            this.Baseparticle.maxParticles = this.maxParticle_2;
            this.Baseparticle.frequency = this.frequency_2;
            UIManager.getRef("amount_tickup_" + this.ui_mode).tickuptime = this.level_2;
            this.playWinLevelSound("winLevel_2")
        }
        else if (this.props.totalCreditWinAmount >= this.threshold_level_2 * this.storeBetValue && this.props.totalCreditWinAmount < this.threshold_level_3 * this.storeBetValue) {
            this.Baseparticle.maxParticles = this.maxParticle_3;
            this.Baseparticle.frequency = this.frequency_3;

            UIManager.getRef("amount_tickup_" + this.ui_mode).tickuptime = this.level_3;
            this.playWinLevelSound("winLevel_3")
        }
        else if (this.props.totalCreditWinAmount >= this.threshold_level_4 * this.storeBetValue) {
            this.Baseparticle.maxParticles = this.maxParticle_4;
            this.Baseparticle.frequency = this.frequency_4;

            UIManager.getRef("amount_tickup_" + this.ui_mode).tickuptime = this.level_4;
        }
    }

    playWinLevelSound(current: any) {
        if (this.props.soundIsPlaying && !this.props.allSoundSFXStop) {
            this.props.playSound([{ name: current, loop: false }]);
        }
    }
    correctCurrencyCodeXAF(amount: string) {
        if ((window as any).GAME_INFO.currency == "XAF") {
            return amount.replace('F', 'FCFA');
        }
        if ((window as any).GAME_INFO.currency == "XOF") {
            return amount.replace('F', 'XOF');
        }
        return amount;
    }
    onTickupUpdate(e?: any) {
        if (this.isClicked) {

            if (this.props.displayInCoins == false) {
                e.value = this.props.winShowerAmount;

            } else {
                e.value = Math.ceil(this.props.winShowerAmount * 10 / this.props.betList[this.props.currentBetIndex]);

            }
            this.props.stopSound([{ name: "tickupSound" }, { name: "coinShowerSound" }]);

        }
        e.updateTextFromOutside = true;
        if (this.props.displayInCoins == false) {

            e.text = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(e.value, true, true, true, true));
        } else {

            e.text = Math.ceil(e.value);
        }

        if (this.props.soundIsPlaying && !this.props.allSoundSFXStop) {
            // this.props.playSound([{ name: "tickupSound", loop: true },{ name: "coinShowerSound", loop: true }]);
            //this.props.playSound([{ name: "coinShowerSound", loop: true }]);
        }
    }

    tweenTo(object: any, property: any, target: any, time: any, easing: any, onchange: any, oncomplete: any, start?: number) {

        new Tween(
            [object],
            {

                [property]: { start: object[property], end: target }
            },
            time || this.tweenTimer,
            easing,
            false, null, null, null, null, false, onchange, oncomplete
        );

    }
    onTickupComplete(e?: any) {
        /*  let timer = TIMER.TimerManager.createTimer(1000);
         timer.on('end', (e: any) => {
             
         });
         timer.start(); */


        if (this.props.displayInCoins == false) {

            e.value = (this.props.winShowerAmount);
        } else {
            e.value = Math.ceil(this.props.winShowerAmount * 10 / this.props.betList[this.props.currentBetIndex]);

        }
        if (e.value == undefined) {
            return
        }
        this.props.stopSound([{ name: "tickupSound" }, { name: "coinShowerSound" }]);


        if (e.value) {
            let tickUpValue = CURRENCY.CurrencyManager.formatCurrencyString(e.value, true, true, true, true);
            if (this.props.displayInCoins == false) {
                tickUpValue = this.correctCurrencyCodeXAF(CURRENCY.CurrencyManager.formatCurrencyString(e.value, true, true, true, true));
            } else {
                tickUpValue = Number(e.value);

            }
            UIManager.getRef("amount_tickup_" + this.ui_mode) && (UIManager.setText("amount_tickup_" + this.ui_mode, tickUpValue));
        }

        this.Baseparticle.emit = false;
        UIManager.getRef("amount_tickup_" + this.ui_mode).alpha = 1

        this.tweenTo(UIManager.getRef("amount_tickup_" + this.ui_mode), 'alpha',
            0
            , 0.8, "easeInCubic", null, () => {
                UIManager.getRef("amount_tickup_" + this.ui_mode).visible = false;
                // UIManager.getRef("winShower_Container_" + this.ui_mode).visible = false;


                UIManager.getRef("amount_tickup_" + this.ui_mode).alpha = 1;
            });


        this.tweenTo(UIManager.getRef("winShower_Container_" + this.ui_mode), 'alpha',
            0
            , 0.8, "easeInCubic", null, () => {

                UIManager.getRef("winShower_Container_" + this.ui_mode).visible = false;


                UIManager.getRef("winShower_Container_" + this.ui_mode).alpha = 1;
            });

        this.props.winShowerStart(false);
        this.props.winShowerShow(false);
        // if (!this.buttonEnabled) {
        this.props.setAllButtonEnable();

        // this.buttonEnabled = true;
        // }

        if (this.props.inFreeGame) {

            if (this.props.featureType == "BONUS" || this.props.featureType == "FREEGAME") {

                if (this.props.featureJustReTriggered) {

                    let nextSpinTimer = 2000;
                    if (this.props.retriggerCount > 0) {
                        let timerRetrigger = TIMER.TimerManager.createTimer(1000);
                        timerRetrigger.on('end', (e: any, data: any) => {
                            this.props.showFeatureRetrigger();
                        })
                        timerRetrigger.start();

                        nextSpinTimer = 3000;
                    }
                    let timer = TIMER.TimerManager.createTimer(nextSpinTimer);
                    timer.on('end', (e: any, data: any) => {

                        this.props.nextAutoplay();
                        this.props.nextFreegame();
                    })
                    timer.start();

                } else {

                    //intro,nextspin
                    let timer = TIMER.TimerManager.createTimer(this.props.outroBannerSkipped ? 0 : 1500);
                    if (this.props.featureJustFinished) {
                        this.props.featureActive(false);
                        this.props.flowManagerCalled(true);
                    }
                    timer.on('end', (e: any, data: any) => {

                        if (this.props.featureJustFinished) {

                            let timer2 = TIMER.TimerManager.createTimer(this.props.outroBannerSkipped ? 0 : 2000);
                            timer2.on('end', (e: any, data: any) => {
                                if (!this.props.inFreeGame) {
                                    return
                                }
                                this.props.stopFreegame();
                                //RAJANU set freegame initial reelgrid
                                let reelData = [
                                    [31, 19, 19, 19, 19, 19, 19, 19, 19],
                                    [31, 31, 19, 31, 31, 31, 19, 19, 31],
                                    [1, 1, 1, 1, 1, 1, 1, 1, 1],
                                    [21, 21, 21, 21, 39, 21, 21, 21, 21],
                                    [52, 46, 10, 34, 28, 28, 46, 52, 52],
                                    [14, 56, 2, 44, 14, 14, 44, 44, 56],
                                    [2, 14, 8, 20]
                                ]
                                let FWReelData;
                                FWReelData = {
                                    stopReels: reelData,
                                }

                                this.props.relGridSymbolCountDisplay([3, 3, 3, 5, 6, 4])

                                this.props.updateReelData(FWReelData);
                                this.props.setApplicationToBaseGameState(true);


                                let timer4 = TIMER.TimerManager.createTimer(this.constantT1);
                                timer4.on('end', (e: any, data: any) => {

                                    this.props.setAllButtonEnable();
                                    this.props.nextAutoplay();
                                    this.props.nextFreegame();
                                })
                                timer4.start();


                            })
                            timer2.start();

                        } else {

                            let nextSpinTimer = 0;
                            if (this.props.retriggerCount > 0) {
                                this.props.showFeatureRetrigger();
                                nextSpinTimer = 3000;
                            }
                            let timer = TIMER.TimerManager.createTimer(nextSpinTimer);
                            timer.on('end', (e: any, data: any) => {
                                this.props.setWinHorizontalSymbolCoOrdinate([]);

                                this.props.nextAutoplay();
                                this.props.nextFreegame();
                                this.props.setAllButtonEnable();

                            })
                            timer.start();

                        }
                    })
                    timer.start();

                }
            } else {

                this.props.nextAutoplay();
                this.props.nextFreegame();
                //this.props.setAllButtonEnable();
            }


        } else {
            this.props.nextAutoplay();
            this.props.nextFreegame();
        }

        // });
        // timer.start();
        this.isClicked = false;


    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        UIManager.getRef("winShowerContainer") && (UIManager.getRef("winShowerContainer").visible = true);
        if (this.props.showWinShower) {
            this.layoutChange(this.props.layoutMode);

        }
    }


    render() {

        //  if (!this.props.showWinShower) {
        ////      return (<></>)
        // }
        return (
            <UIManager id={"winShowerContainer"} name={"winShowerContainer"} type={"Container"}
                ref={i => this.winShowerContainer = i}>
                {
                    this.displayUI && this.displayUI.map((i: any) =>
                        <UIManager key={`UIManager-${Math.random()}`} langObj={this.props.langObj} type={i.type}
                            app={this.app} configGame={configGame} constant={constant}
                            id={i.id} name={i.name} {...i} tickupupdate={this.onTickupUpdate.bind(this)}
                            tickupComplete={this.onTickupComplete.bind(this)} mouseOver={this.handleEventMouseOver} mouseOut={this.handleEventMouseOut} />)
                }
            </UIManager>
        );
    }


}

export default withPixiApp(connect(
    (state: Pick<IStore, 'wrapperState' | 'betPanelState' | 'winShowerState' | 'retriggerState' | 'freegameState' | 'soundState' | 'behaviourState' | 'applicationState' | 'basegameState'>): IStateToProps =>
    ({
        layoutMode: state.applicationState.layoutMode,
        startWinShower: state.winShowerState.startWinShower,
        showWinShower: state.winShowerState.showWinShower,
        winShowerAmount: state.winShowerState.winShowerAmount,
        betList: state.betPanelState.coinList,
        inFreeGame: state.freegameState.inFreeGame,
        currentBetIndex: state.betPanelState.selectedCoin,
        totalCreditWinAmount: state.behaviourState.totalCreditWinAmount,
        soundIsPlaying: state.soundState.soundIsPlaying,
        displayInCoins: state.behaviourState.displayInCoins,
        featureType: state.basegameState.featureType,
        featureJustReTriggered: state.freegameState.featureJustReTriggered,
        featureJustFinished: state.freegameState.featureJustFinished,
        retriggerCount: state.retriggerState.retriggerCount,
        outroBannerSkipped: state.behaviourState.outroBannerSkipped,
        freegameSpinCountRemaining: state.freegameState.freegameSpinCountRemaining,
        allSoundSFXStop: state.soundState.allSoundSFXStop,
        clickToEnterFeature: state.wrapperState.clickToEnterFeature,
    }),
    (dispatch: Dispatch): IDispatchToProps => ({

        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutssActions.setApplicationLayoutObject(layoutobjectlist)),
        setAllButtonEnable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonEnable(exceptBtnList)),
        nextAutoplay: (): any => dispatch(basegameAction.nextAutoplay()),
        nextFreegame: (): any => dispatch(freegameAction.nextFreegame()),
        setAllButtonDisable: (exceptBtnList: Array<string>): any => dispatch(buttonActions.setAllButtonDisable(exceptBtnList)),
        winShowerStart: (startWinShower: boolean, winShowerAmount: number): any => dispatch(winShowerActions.winShowerStart(startWinShower, winShowerAmount)),
        winShowerShow: (showWinShower: boolean): any => dispatch(winShowerActions.winShowerShow(showWinShower)),
        playSound: (soundName: any): any => dispatch(soundActions.playSound(soundName)),
        stopSound: (soundName: any): any => dispatch(soundActions.stopSound(soundName)),

        setWinHorizontalSymbolCoOrdinate: (winSymbolCoOrdinate: any): any => dispatch(horizontalSymbolActions.setWinSymbolCoOrdinate(winSymbolCoOrdinate)),
        showFeatureRetrigger: (): any => dispatch(retriggerActions.showFeatureRetrigger()),
        stopFreegame: (): any => dispatch(freegameAction.stopFreegame()),
        relGridSymbolCountDisplay: (displayReelGridSymbolCount: any): any => dispatch(reelgridAction.relGridSymbolCountDisplay(displayReelGridSymbolCount)),
        updateReelData: (result_reel: any): any => dispatch(reelgridAction.updateReelData(result_reel)),
        setApplicationToBaseGameState: (basegamestate: boolean): any => dispatch(basegameAction.setApplicationToBaseGameState(basegamestate)),
        flowManagerCalled: (callFlowManager: boolean): any => dispatch(flowManagerAction.flowManagerCalled(callFlowManager)),
        featureActive: (isFeatureActive: boolean): any => dispatch(gameRandomWildActions.featureActive(isFeatureActive)),
    }))(withWinShowerConfiguration(WinShower)));